


















import {Vue, Component, Watch, Prop} from 'vue-property-decorator';
import ecChinaMap from '../../../../dv-pure-render/ec-china-map/ec-china-map.js';

@Component({
    components: {}
})
export default class App extends Vue {

    @Prop({})
    entityType: any;

    @Prop({})
    userData: any;

    @Watch('userData')
    onUserData(userData: any, oldVal: any) {
        this.drawChinaMap();
    }

    mounted () {
        this.drawChinaMap();
    }

    drawChinaMap () {
        let cityArr = [];
        let cityTree = this.userData.LeftData;
        for (let key in cityTree) {
            let cityName = key.split(':')[1];
            let cityRank = cityTree[key].length;
            cityArr.push({
                name: cityName,
                rank: cityRank,
                selected: true
            });
        }
        cityArr.sort((a, b) => b.rank - a.rank);

        ecChinaMap({
            dom: this.$refs.mapMount,
            cityArr,
            echarts,
        });
    }
}
